import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { QualifyBorrowerStore } from '../stores';

export const useQualifyBorrowerStore = () => useContext<{
  qualifyBorrowerStore: QualifyBorrowerStore
}>(StoreContext);
